<template>
  <section class="mb-8">
    <h3
      class="font-roboto text-xl font-bold mb-4"
      id="authorInformationTitle">
      Authors
    </h3>
    <ul class="space-y-4">
      <AuthorListItem
        v-for="(author, index) in authors"
        :key="author.id"
        :id="author.id"
        :firstName="author.firstName"
        :initials="author.initials"
        :lastName="author.lastName"
        :isCorresponding="author.isCorresponding"
        :email="author.email"
        :orcid="author.orcid"
        :affiliation="author.affiliation"
        :index="index"
        :showEdit="false"
        :showCorrespondingPill="true"
      />
    </ul>
    <AddFileCard
      v-if="!authors.length"
      anchor-link="/submission/author-info"
      scroll-to-id="authorInformationTitle"
      data-testid="add-authors-card"
    />
    <InlineWarningMessage
      v-if="requires1AuthorErrorMessage"
      errorTestId="no-authors"
      :errorMessage="requires1AuthorErrorMessage"/>
  </section>
</template>

<script setup lang="ts">
import { Author } from '@/types'
import { useStore } from 'vuex'
import { useField } from 'vee-validate'
import { watch } from 'vue'
import InlineWarningMessage from '../common/InlineWarningMessage.vue'
import AuthorListItem from '../author/AuthorListItem.vue'
import AddFileCard from '../common/AddFileCard.vue'

const store = useStore()

const authors = store.state.activeSubmission.authors as Author[]
const { errorMessage: requires1AuthorErrorMessage, validate: validateRequires1Author } = useField('input-authors', 'at-least-one-author-required', {
  initialValue: authors,
})

watch(() => store.state.submissionAttemptCounter, () => {
  validateRequires1Author()
})
</script>
